var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeFill = function SvgLikeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.878 10.17c-4.193-4.194-11.014-4.192-15.206 0l-.672.672-.672-.672c-2.031-2.031-4.73-3.149-7.603-3.149s-5.572 1.118-7.603 3.149-3.149 4.73-3.149 7.603 1.119 5.571 3.149 7.603L24 41.252l15.877-15.877c2.031-2.031 3.149-4.73 3.149-7.603s-1.118-5.572-3.148-7.602"
  })))));
};
export default SvgLikeFill;